// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__37Kmq","long":"styles_long__ykcJo","tableValue":"styles_tableValue__2vICX","textArea":"styles_textArea__28Mqt"};